<template>
<v-text-field
  clearable
  placeholder='Search'
  prepend-icon='search'
  v-model='searchString'
  v-bind='attrs'
  @keydown.esc.stop='searchString=""' />
</template>
<script>
export default {
  name: 'SearchField',
  props: {
    value: { type: String, required: true },
    attrs: { type: Object, default: () => { return {} } }
  },
  data () {
    return {
      searchString: null
    }
  },
  watch: {
    value: {
      immediate: true,
      handler () {
        this.searchString = this.value
      }
    },
    searchString () {
      this.$emit('input', this.searchString)
    }
  }
}
</script>



// WEBPACK FOOTER //
// SearchField.vue?359353ae